import { httpService } from "../http";
import { Data } from "../service";
import { InvoiceDetailType, InvoiceOrderType, InvoiceType, UninvoiceType } from "./bill";
const REACT_APP_GO_MICRO = process.env.REACT_APP_GO_MICRO;

interface UninvoiceParam {
  page: number
  pageSize: number
  bizName: string
  status: number
}

/// 未申请开票订单
export const getUninvoiceList = async (param:UninvoiceParam): Promise<Data<UninvoiceType>> => {
  return httpService.get(`/mp2c-micro/platform/v1/invoice/order/page`, param, { baseURL: REACT_APP_GO_MICRO });
}
interface InvoiceParam {
  page: number
  pageSize: number
  bizName: string
}
/// 已申请开票列表
export const getInvoiceList = async (param:InvoiceParam): Promise<Data<InvoiceType>> => {
  return httpService.get(`/mp2c-micro/platform/v1/invoice/apply/page`, param, { baseURL: REACT_APP_GO_MICRO });
}

interface InvoiceDetailParam {
  outInvoiceId: string
  bizName: string
}

/// 开票详情
export const getInvoiceDetail = async (param:InvoiceDetailParam): Promise<InvoiceDetailType> => {
  return httpService.get(`/mp2c-micro/platform/v1/invoice/apply/detail`, param, { baseURL: REACT_APP_GO_MICRO });
}
interface InvoiceOrderParam {
  page: number
  pageSize: number
  outInvoiceId: string
  bizName: string
}
/// 关联订单
export const getInvoiceOrder = async (param:InvoiceOrderParam): Promise<Data<InvoiceOrderType>> => {
  return httpService.get(`/mp2c-micro/platform/v1/invoice/apply/order/page`, param, { baseURL: REACT_APP_GO_MICRO });
}

interface WXSignParam {
  platform: string
  url: string
}

export const getWXSign = async (param:WXSignParam): Promise<any> => {
  return httpService.post(`/api/mp2c/oa/sign`, param, { baseURL: REACT_APP_GO_MICRO });
}

// export async function sign(): Promise<> {
//   try {
//     const result = await http({
//       url: API_SDK_SIGN,
//       method: 'POST',
//       body: { platform: 'mio-srv-oa', url: window.location.href }
//     })

//     return Promise.resolve(result)
//   } catch (error) {
//     return Promise.reject(error)
//   }
// }

// export async function initWX() {
//   const result = await sign()

//   wx.config({
//     debug: false,
//     jsApiList: [],
//     ...result.data.sign
//   })
// }